<template>
    <div>
        <div
                class="flex justify-between text-sm cursor-pointer"
                v-on:mouseover="show = true"
                v-on:mouseleave="show = false"
        >
            <div class="flex-none p-2 cursor-pointer text-xs" v-on:click="data.update('hide', [index])">
                <i
                        class="fa fa-circle"
                        v-bind:style="'color:' + color"
                ></i>
            </div>

            <div class="flex-grow flex p-2" v-bind:class="{'opacity-50': !item.visible}" @click="scroll">
                <div class="flex-grow">
                    <span class="font-medium">{{ item.name }}</span>
                    <span class="font-light text-grey" v-show="isModified">*</span>
                </div>
            </div>

            <div v-bind:class="{'invisible': !show}" @click="scroll" class="p-2 text-grey">
                <i class="fa fa-pencil"></i>
            </div>

        </div>

        <modal v-if="popup" @close="popup = false">
            <analyze-series :item="item" :index="index"></analyze-series>
        </modal>
    </div>

</template>


<script>
    import Data from "../Data";

    export default {
        props: ['item', 'index'],

        data: function () {
            return {
                data: Data,
                popup: false,
                show: false,
            };
        },

        computed: {
            isModified: function () {
                return this.item.steps.length > 0;
            },
            color: function () {
                if (this.item.visible) {
                    return this.item.color;
                }

                return 'grey';
            }
        },

        methods: {
            scroll: function () {
                this.popup = true;
            }
        }

    }
</script>